import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Layout from "../../../components/layout";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import {
  GeneracionContactCenterDispatcher,
  generacionContactCenterDispatcher
} from "./GeneracionContactCenter.dispatcher";
import {
  GeneracionContactCenterStore,
  generacionContactCenterStore
} from "./GeneracionContactCenter.store";
import GeneracionContactCenterComponent from "../../../components/comisionesContactCenter/generacion";

interface Props
  extends GeneracionContactCenterStore,
    GeneracionContactCenterDispatcher {}

@ReduxConnect(generacionContactCenterStore, generacionContactCenterDispatcher)
export default class GeneracionContactCenterContainer extends Component<Props> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Generación de Comisiones - Contact Center" />
          <GeneracionContactCenterComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
